import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { Col, Row } from 'react-styled-flexboxgrid'
import { Button, HeroCodeSnippet, MetricsPills } from '..'
import variables from '../../styles/variables'
import * as styles from './styles'

const propTypes = {
  content: PropTypes.object.isRequired
}

const Landing = (props) => {
  const { content } = props
  return (
    <styles.IntroContainer>
      <styles.IntroSection>
        <Row>
          <Col xs={12} sm={6}>
            <styles.IntroHeader>
              Predict <span className="text-accent">smarter</span> with a single query
            </styles.IntroHeader>
            
            <styles.PlainEnglishExplainer>
              Query your data & get instant predictions—no model training required.
            </styles.PlainEnglishExplainer>
            
            <styles.IntroTagline>
              { content.tagline }
            </styles.IntroTagline>

            <styles.IntroTagline>
              { content.footerTagline }
            </styles.IntroTagline>
            
            <styles.ButtonContainer>
              <styles.ButtonGroup>
                {content.primaryAction && (
                  <Link to={content.primaryAction.url}>
                    <Button size="large" type="plain">
                      {content.primaryAction.text}
                    </Button>
                  </Link>
                )}
                {content.secondaryAction && (
                  <Link to={content.secondaryAction.url}>
                    <Button size="large" type="outline" buttonColor={variables.colors.white} textColor={variables.colors.white} hoverTextColor={variables.colors.deepIndigo}>
                      {content.secondaryAction.text}
                    </Button>
                  </Link>
                )}
                {content.tertiaryAction && (
                  <Link to={content.tertiaryAction.url}>
                    <Button size="large" type="outline" buttonColor={variables.colors.white} textColor={variables.colors.white} hoverTextColor={variables.colors.deepIndigo}>
                      {content.tertiaryAction.text}
                    </Button>
                  </Link>
                )}
              </styles.ButtonGroup>
              
              <styles.PerformanceBadgeContainer>
                <MetricsPills />
              </styles.PerformanceBadgeContainer>
            </styles.ButtonContainer>
            
            <styles.ComplianceNote>
              EU-hosted (Ireland) • GDPR-ready • AES-256 / TLS 1.3
            </styles.ComplianceNote>
          </Col>

          <Col xs={12} sm={6}>
            <styles.HeroQueryContainer>
              <HeroCodeSnippet />
            </styles.HeroQueryContainer>
          </Col>
        </Row>
      </styles.IntroSection>

    </styles.IntroContainer>
  )
}

Landing.propTypes = propTypes

export default Landing
